import PiniaStore from "@/stores";
import { defineStore } from "pinia";
import { JwtHelper } from "@/helpers/utilities/JwtHelper";
import apiSkobo from "@/helpers/api/apiSkobo";
import vuexStore from "@/helpers/store";
import { useSettingsStore } from "@/stores/settings";
import { SessionHelper } from "@/helpers/utilities/sessionHelper";

export const useInstitutionsStore = defineStore("institutions", {
  state: () => ({
    myInstitutionsState: [],
    myActiveInstitutionIdState: null
  }),

  actions: {
    async loadMyInstitutions() {
      if (this.myInstitutionsState.length === 0) {
        this.reloadMyInstitutions();
      }
    },

    async reloadMyInstitutions() {
      try {
        const settingsStore = useSettingsStore();

        const response = await apiSkobo.get("/Institution/User/All");
        let institutions = response.data;
        institutions = institutions.sort((a, b) => a.displayName.localeCompare(b.displayName, settingsStore.language));
        this.myInstitutionsState = institutions;
        // eslint-disable-next-line no-empty
      } catch {}
    },

    async switchInstitution(newInstitutionId) {
      const response = await apiSkobo.post(`/me/auth/swap/${newInstitutionId}`);
      PiniaStore.resetStore();
      vuexStore.dispatch("resetStore", null, { root: true });
      SessionHelper.login(response.data);

      const settingsStore = useSettingsStore();
      await settingsStore.loadSetup();

      this.setActiveInstitutionFromToken();
    },

    setActiveInstitutionFromToken() {
      this.myActiveInstitutionIdState = JwtHelper.getInstitutionId(SessionHelper.nctSessionToken());
    }
  },

  getters: {
    myInstitutions: state => state.myInstitutionsState,
    myActiveInstitutionId: state => {
      return state.myActiveInstitutionIdState;
    },
    institution: state => institutionId => state.myInstitutionsState.find(i => i.institutionId === institutionId),
    activeInstitution(state) {
      return state.myInstitutionsState.find(i => i.institutionId === this.myActiveInstitutionId);
    }
  }
});
